/*
    Главная страница
*/

import { analyticsClickEvent } from './Analytics';
import { analyticsRunHandle } from './Analytics';

import ShareImg from './shareImg';
import Share from "./share";

const share = new Share();

const $pageWrapper = $('.js-page-wrapper');
const $startBtn = $('.js-start-btn');
const $tooltip = $('.js-tooltip');
const $finishCircle = $('.js-finish-circle');
const $cardsImages = $('.js-cards-images');
const $resultContent = $('.js-result-content');
const $resultText = $('.js-result-text');
const $closeTooltip = $('.js-close-tooltip');
const $buttonsWrapper = $('.js-buttons-wrapper');
const $shareBtn = $('.js-share-btn');
const $defaultShareBtn = $('.js-default-share-btn');
const $defaultShareWrap = $('.js-default-share-wrap');
const $backBtn = $('.js-back-btn');
const $handSlider = $('.js-hand-slider');
const $handMobileSlider = $('.js-hand-slider-mobile');
const $audio = $('.js-audio');
const $secretButton = $('.js-secret-button');
const $secretImg = $('.js-secret-img');
const $openForm = $('.js-open-form');
const $facebookBtn = $('.js-facebook-btn');
const $vkBtn = $('.js-vkontakte-btn');
const $secretContent = $('.js-secret-content');
const $shareDefaultBtn = $('.js-share-default-btn');

let cardsStack = $('.js-cards-stack');
let cardsCol = $('.js-cards-col');
let imgIndex;
let images;
let imgNamesAr = [];
let imgCountAr = [11, 11, 10];
let animationStep;
let arrCurrIndexes;
let secretStr = '';


$shareDefaultBtn.on('click', function () {
    analyticsClickEvent($(this));
});

$facebookBtn.on('click', function (e) {
    analyticsClickEvent($facebookBtn);
    //e.preventDefault();
});

$vkBtn.on('click', function (e) {
    analyticsClickEvent($vkBtn);

    //e.preventDefault();
});

$defaultShareBtn.on('click', function (e) {
    analyticsClickEvent($defaultShareBtn);

    $defaultShareBtn.toggleClass('_active');
    $defaultShareWrap.toggleClass('_visible');

    e.preventDefault();
});

App.D.on('mouseup', function(e) {
    if (!$defaultShareBtn.is(e.target) && $defaultShareBtn.has(e.target).length === 0) {
        $defaultShareBtn.removeClass('_active');
        $defaultShareWrap.removeClass('_visible');
    }
});

$backBtn.on('click', function (e) {
    showButtons(1);

    e.preventDefault();
});

$shareBtn.on('click', function (e) {
    showButtons(2);

    analyticsClickEvent($shareBtn);

    e.preventDefault();
    share.render();
});

$startBtn.on('click', function (e) {
    $pageWrapper.addClass('_start');
    $tooltip.addClass('_showen');

    generateImagesData();
    loadAudio();
    analyticsClickEvent($startBtn);

    e.preventDefault();
});

$closeTooltip.on('click', function (e) {
    $tooltip.addClass('_hidden');

    analyticsClickEvent($closeTooltip);

    setTimeout(function () {
        $tooltip.removeClass('_showen _hidden');
        $pageWrapper.addClass('_step1');
    }, 1000);

    e.preventDefault();
});

$tooltip.on('click', function (e) {
    $tooltip.addClass('_hidden');
    $pageWrapper.addClass('_animating');

    if (!$closeTooltip.is(e.target) && $closeTooltip.has(e.target).length === 0) {
        analyticsClickEvent($tooltip);
    }


    setTimeout(function () {
        $tooltip.removeClass('_showen _hidden');
        $pageWrapper.addClass('_step1');

        if (!App.mobile) {
            setTimeout(function () {
                animatingCircle();
            }, 1000);

            setTimeout(function () {
                $pageWrapper.removeClass('_animating');
            }, 1700);
        } else {
            $pageWrapper.removeClass('_animating');
        }
    }, 1000);

    e.preventDefault();
});

$handSlider.slider({
    orientation: 'vertical',
    range: 'min',
    min: 1,
    max: 9,
    value: 9,
    start: function() {
        analyticsRunHandle();
    },
    slide: function( event, ui ) {
        playSound('handle');

        let currStep = 9 - ui.value;

        animationStep = ui.value;

        $('.js-hand-element').css({
            'left': `-${currStep * 100}%`
        });
    },
    stop: function( event, ui ) {
        let currStep = 9 - ui.value;

        animationStep = ui.value;

        if (currStep === 8) {
            playSound('handle-tap');

            setTimeout(function () {
                $pageWrapper.addClass('_animating _fill');
                fillCards();
                runAnimation();
                returnLeverAnimation();
            }, 500);
        } else {
            returnLeverAnimation();
        }
    }
});

$handMobileSlider.slider({
    orientation: 'horizontal',
    range: 'min',
    min: 1,
    max: 15,
    value: 1,
    start: function() {
        analyticsRunHandle();
    },
    slide: function( event, ui ) {
        playSound('handle');
        let currStep = ui.value;

        if (currStep !== 15) {
            returnLeverAnimation();
        }
    },
    stop: function( event, ui ) {
        let currStep = ui.value;

        if (currStep === 15) {
            playSound('handle-tap');

            setTimeout(function () {
                $pageWrapper.addClass('_animating _fill');
                fillCards();
                runAnimation();
                returnLeverAnimation();
            }, 500);
        } else {
            returnLeverAnimation();
        }
    }
});

$secretButton.first().addClass('_first');

/* Это пасхалка, если ты ее нашел в коде, то никому не говори =)  */
$secretButton.on('click', function () {
    let $currBtn = $(this);

    if ($currBtn.hasClass('_first')) {
        secretStr = '';
        $secretButton.removeClass('_active');
    }

    if (!$currBtn.hasClass('_active')) {
        secretStr += $currBtn.data('val');
        $currBtn.addClass('_active');
    }

    checkSurprise();
});

preloader();

function checkSurprise() {
    if (secretStr === 'cpeople') {
        runSurpriseAnimation();
    }
}

function runSurpriseAnimation() {
    $secretButton.removeClass('_active');

    $pageWrapper.addClass('_animating _fill');
    fillCards(true);
    runAnimation(true);
}

function generateImagesData() {
    imgNamesAr = [];

    $cardsImages.each(function (index, el) {
        let currImages = [];

        $(el).find('img').each(function (imgIndex, imgEl) {
            currImages.push($(imgEl).attr('src'));
        });

        imgNamesAr.push(currImages);
    });

}

function playSound(_type) {
    $audio.filter(`[data-type="${_type}"]`)[0].play();
}

function loadAudio() {
    $audio.each(function (index, el) {
        $(el)[0].play();
        $(el)[0].pause();
    });
}

function showButtons(_index) {
    $buttonsWrapper.removeClass(`_step1 _step2`);

    setTimeout(function () {
        $buttonsWrapper.addClass(`_step${_index}`);
    }, 500);
}

function returnLeverAnimation() {
    $handSlider.slider('value', 9);
    $handMobileSlider.slider('value', 1);

    let i = animationStep;
    let intervalFlag;

    if (i < 9) {
        intervalFlag = setInterval(function () {
            $('.js-hand-element').css({
                'left': `-${(9 - i) * 100}%`
            });

            i++;

            if (i > 9) {
                clearInterval(intervalFlag);
            }
        }, 40);
    }
}

function animatingCircle() {
    let bar = new ProgressBar.Circle($finishCircle[0], {
        strokeWidth: 1,
        easing: 'easeInOut',
        duration: 700,
        color: '#fff',
        svgStyle: null
    });

    bar.animate(1.0);
}

function getImgIndex() {
    let randImgIndex = Math.ceil(Math.random() * arrCurrIndexes.length) - 1;

    imgIndex = arrCurrIndexes[randImgIndex];

    arrCurrIndexes.splice(randImgIndex, 1);
}

function fillCards(_isSecret) {
    generateImagesData();
    cardsCol.removeClass('_playing-1 _playing-2 _playing-3');
    $resultContent.removeClass('_showen');

    cardsStack.each((index, el) => {
        let currImgCounts = _isSecret ? imgCountAr[index] - 1 : imgCountAr[index];

        $(el).html('');
        images = '';

        arrCurrIndexes = [];

        for (let i = 0; i < $cardsImages.eq(index).find('img').length; i++) {
            arrCurrIndexes.push(i);
        }

        if (_isSecret) {
            images += `<img src="${$secretImg.eq(index).data('src')}" alt="" class="card-item" data-text="${$secretImg.eq(index).html()}">`;
            $pageWrapper.addClass('_secret');
        } else {
            $pageWrapper.removeClass('_secret');
        }

        for (let i = 0; i < currImgCounts; i++) {
            // Рандомная картинка
            getImgIndex();

            let currText = $cardsImages.eq(index).find('img').eq(imgIndex).data('text');

            images += `<img src="${imgNamesAr[index][imgIndex]}" alt="" class="card-item" data-text="${currText}">`;
        }

        $(el).html(images);
    });
}


function runAnimation(_isSecret) {
    $buttonsWrapper.removeClass(`_step1 _step2`);

    setTimeout(function () {
        cardsCol.eq(0).addClass('_playing-1');
        cardsCol.eq(1).addClass('_playing-2');
        cardsCol.eq(2).addClass('_playing-3');

        playSound('reel');

        setTimeout(function () {
            if (_isSecret) {
                $resultText.html($secretContent.html());
            } else {
                let _text1 = cardsStack.eq(0).find('img').eq(0).data('text');
                let _text2 = cardsStack.eq(1).find('img').eq(0).data('text');
                let _text3 = cardsStack.eq(2).find('img').eq(0).data('text');

                $resultText.html(`${_text1} <br>${_text2} <br>${_text3}`);
                $resultContent.data('label', `${_text1} ${_text2} ${_text3}`);
                $shareBtn.data('label', `${_text1} ${_text2} ${_text3}`);
                $openForm.data('label', `${_text1} ${_text2} ${_text3}`);
            }

            $resultContent.addClass('_showen');

            /*if (!$buttonsWrapper.hasClass('_step1') && !$buttonsWrapper.hasClass('_step2')) {
                setTimeout(function () {
                    showButtons(1);
                }, 500);
            }*/

            setTimeout(function () {
                if (!$buttonsWrapper.hasClass('_step1') && !$buttonsWrapper.hasClass('_step2')) {
                    setTimeout(function () {
                        showButtons(1);
                    }, 500);
                }
            }, 2000);

            setTimeout(function () {
                $pageWrapper.removeClass('_animating');

              new ShareImg().render();

            }, 3000);

            playSound('result');
            analyticsClickEvent($resultContent);
        }, 3000);
    }, 100);
}


function preloader() {
    App.W.on('load', function() {
        let loader = $('.js-preloader');
        let wHeight = $(window).height();
        let wWidth = $(window).width();
        let i = 0;

        loader.css({
            top: wHeight / 2 - 2.5,
            left: wWidth / 2 - 200
        });

        while (i <= 400) {
            loader.animate({
                width: i
            },10);

            i+=3;
        }

        if (i === 402) {
            loader.animate({
                left: 0,
                width: '100%'
            });

            loader.animate({
                top: '0',
                height: '100vh'
            });
        }

        setTimeout(function() {
            App.H.addClass('_visible');
        }, 3500);
    });
}


// WEBPACK FOOTER //
// ./_src/js/modules/PageMain.js